import script from "./SearchResults.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchResults.vue?vue&type=script&setup=true&lang=ts"

import "./SearchResults.vue?vue&type=style&index=0&id=01b048cc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01b048cc"]])

export default __exports__